import React from 'react';
// import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
// import Box from "@material-ui/core/Box";


export default function NotAvailability(props) {

    return (
        <React.Fragment>
            <div>
                {/* <Paper elevation={0}> */}
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={2}
                >
                    <Grid item xs>
                        <img src={"/Images/logoAtom.png"} width="150px" alt="Logo"></img>
                    </Grid>
                    {/* <Grid item xs> */}
                    <Typography variant="h6" gutterBottom>
                        No se puede realizar la reserva.
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        El hotel {props.hotelName} esta en penalidad.
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        Favor comunicarse con Atom para realizar la reserva.
                    </Typography>
                    {/* </Grid> */}

                </Grid>
                {/* </Paper> */}
            </div>
        </React.Fragment>
    );
}
